<template>
  <parent>
    <div class="h-100">
      <div class="full-width-content">
        <div class="container">
          <div class="organization-settings col-xl-9 m-auto">
            <paper-tabbed
              class="full-height-content mb-0"
              @tabChanged="e => changeTab(e)"
            >
              <paper-tab
                v-if="$can('get', 'organizations', 'captain')"
                title="General"
                :active="activeTab == '0'"
              >
                <general v-if="activeTab == '0'" />
              </paper-tab>
              <paper-tab
                v-if="$can('list', 'users', 'captain')"
                title="Users"
                :active="activeTab == '1'"
              >
                <users v-if="activeTab == '1'" />
              </paper-tab>
              <paper-tab
                v-if="$can('list', 'roles', 'captain')"
                title="Roles"
                :active="activeTab == '2'"
              >
                <roles v-if="activeTab == '2'" />
              </paper-tab>
              <template #tabs-end>
                <b-dropdown
                  variant="bg-white"
                  class="ml-auto edit"
                  no-caret
                  dropleft
                >
                  <template #button-content>
                    <GjIcon name="Moreoptions" />
                  </template>
                  <b-dropdown-item @click="showEdit = true">
                    Edit Organization <GjIcon
                      name="Edit"
                      class="icon-right"
                    />
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </paper-tabbed>
          </div>
        </div>
      </div>
      <edit
        v-if="showEdit"
        @close="showEdit = false"
      />
    </div>
  </parent>
</template>
<script>
import PaperTabbed from '@/components/paper/PaperTabbed.vue'
import PaperTab from '@/components/paper/PaperTab.vue'
import General from './general/General.vue'
import Edit from './general/Edit.vue'
import Users from './users/Users.vue'
import Roles from './roles/Roles.vue'

export default {
  name: 'Settings',
  components: {
    PaperTabbed,
    PaperTab,
    General,
    Edit,
    Users,
    Roles,
  },
  data() {
    return {
      activeTab: 0,
      showEdit: false,
    }
  },
  created() {
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab
    }
    this.$store.dispatch('organization/fetchCountries').catch(error => {
      this.errorToast(
          error.response?.data?.errors[0] || 'Something went wrong while fetching countries',
      )
    })
  },
  methods: {
    changeTab(e) {
      this.activeTab = e
      // eslint-disable-next-line no-restricted-globals
      history.pushState({}, null, `${this.$route.path}?tab=${e}`)
    },
  },
}
</script>
<style lang="scss" scoped>
.full-width-content {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
::v-deep {
  .paper {
    .tabs {
      height: 100%;
      display: flex;
      flex-direction: column;
      .tab-content {
        height: 100%;
        overflow: hidden;
        padding-top: 40px;
        .tab-pane {
          height: 100%;
        }
      }
    }
  }
}
.edit::v-deep {
  .dropdown-toggle {
    height: auto;
    align-items: flex-start;
    padding: 0;
    border-width: 0;
  }
}
</style>
